import SubmissionInitiatedIcon from "../../../svg/submissionInitiated";

const DraftSubmissionHeader = () => {
  return (
    <div className="draft-submission-header--container flex flex-col items-center justify-center gap-2">
      <SubmissionInitiatedIcon />
      <div className="draft-submission-header--text text-h10 font-bold text-primaryGray-1">
        Draft Created
      </div>
      <div className="draft-submission-header--subText text-center text-small font-regular leading-5 text-primaryGray-4">
        Draft has been created on the payer flow, you can <br /> review it and
        submit on the portal
      </div>
    </div>
  );
};

export default DraftSubmissionHeader;
